
// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { UserService } from '@/services/user.service'
import { getAllSellers, putSeller } from '@/services/seller.service'
import { ErrorMessages } from '@/helpers/constants'

@Component({
  components: {
    SellerHeader,
  },
})
export default class ListSellers extends Vue {
  sellers: [] = []
  sellersFiltered: [] = []
  sellersTotalPages = 1
  sellersPage = 1
  filter = ''
  status: string = 'all'
  showDeactivateDialog = false
  sellerToDeactivate: any = null

  get canViewSellerProducts(): boolean {
    return UserService.isBusinessAdmin(UserService.getCurrentUser())
  }

  async getSellers(page?, query?, status?) {
    try {
      const { meta, data } = await getAllSellers(page, query, status, 25)

      // Length de paginador
      this.sellersTotalPages = meta.last_page

      this.sellers = data
      this.sellersFiltered = this.sellers

      // Asigno valor a variable status para que cambie de color el boton (en caso de que haya habido algun cambio)
      this.status = status

      // Aisgno valor a pagina para que muestre la pagina actual en paginador
      this.sellersPage = page
    } catch (error) {
      console.error(error)
      Vue.$toast.error(ErrorMessages.COMMON)
    }
  }

  @Watch('sellersPage', { immediate: true, deep: true })
  onSellersPageChange(nextPage: number) {
    this.getSellers(nextPage, this.filter, this.status)
  }

  async setSellerActive(value, seller) {
    if (!value && seller.active == 1) {
      this.sellerToDeactivate = seller
      this.showDeactivateDialog = true
      return
    }
    
    this.executeToggleActive(value, seller)
  }

  async executeToggleActive(value, seller) {
    const body = {
      user: {
        active: value ? 1 : 0,
      },
    }

    const response: any = await putSeller(seller.id, body)

    const message = value ? 'activado' : 'desactivado'

    if (response.status == 200) {
      Vue.$toast.success(`Usuario ${message} correctamente`)
      seller.active = !seller.active
    } else {
      Vue.$toast.error('Ha ocurrido un error actualizando el usuario')
    }
  }

  confirmDeactivate() {
    if (this.sellerToDeactivate) {
      this.executeToggleActive(false, this.sellerToDeactivate)
      this.sellerToDeactivate = null
    }
    this.showDeactivateDialog = false
  }

  cancelDeactivate() {
    if (this.sellerToDeactivate) {
      // Force re-render of the toggle button to revert visual state
      const id = this.sellerToDeactivate.id
      const index = this.sellersFiltered.findIndex((s: any) => s.id === id)
      if (index !== -1) {
        const s: any = this.sellersFiltered[index]
        Vue.set(this.sellersFiltered, index, { ...s })
      }
    }
    this.sellerToDeactivate = null
    this.showDeactivateDialog = false
  }

  createSeller() {
    this.$router.push('/seller/administration/seller-create')
  }
}
